import type { U3141ChainPdfAlerteType } from '../U3141Service';

/** Clés i18n (namespace u3141) pour les types d'alerte du job reconstitution PDF. */
const ALERTE_TYPE_I18N_KEYS: Record<U3141ChainPdfAlerteType, string> = {
  branches_absentes_du_pdf: 'lblChainPdfAlerte.branches_absentes_du_pdf',
  lien_deduit_du_numerotage_seulement: 'lblChainPdfAlerte.lien_deduit_du_numerotage_seulement',
  aucun_lien_detecte: 'lblChainPdfAlerte.aucun_lien_detecte',
};

export function u3141IsKnownChainPdfAlerteType(type: string): type is U3141ChainPdfAlerteType {
  return type in ALERTE_TYPE_I18N_KEYS;
}

/**
 * Retourne la clé i18n (ns u3141) pour un type d'alerte, ou null si type inconnu
 * (afficher alors le code technique brut).
 */
export function u3141ChainPdfAlerteTypeI18nKey(type: string): string | null {
  if (!u3141IsKnownChainPdfAlerteType(type)) return null;
  return ALERTE_TYPE_I18N_KEYS[type];
}

/**
 * Libellé affichable d'un type d'alerte via `t` (react-i18next).
 * Types inconnus : retourne le code technique tel quel.
 */
export function u3141FormatChainPdfAlerteLabel(
  type: string,
  t: (key: string, options?: { ns?: string }) => string,
  ns = 'u3141'
): string {
  const key = u3141ChainPdfAlerteTypeI18nKey(type);
  if (!key) return type;
  const label = t(key, { ns });
  return label && label !== key ? label : type;
}
